import React from "react";
import { MessageCircle, Phone, MapPin } from "lucide-react";
import { WA_NUMBER_LOCAL, buildWaLinkGeneric } from "../lib/whatsapp";

export default function Footer() {
  const waLink = buildWaLinkGeneric(
    "Halo, saya ingin konsultasi motor Yamaha. Mohon info stok & promo terbaru area Kalimantan Barat."
  );

  return (
    <footer id="kontak" className="bg-[#05132e] text-white/85 mt-6" data-testid="site-footer">
      <div className="y-container py-8 sm:py-10 grid gap-6 sm:grid-cols-3">
        <div>
          <div className="flex items-center gap-2 mb-2">
            <span className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-[#e60012] text-white font-black text-sm">Y</span>
            <span className="font-display font-extrabold text-base">
              Yamaha<span className="text-[#e60012]">Kalbar</span>
            </span>
          </div>
          <p className="text-white/60 text-xs leading-relaxed">
            Sales pribadi motor Yamaha area Kalimantan Barat. Konsultasi & pemesanan via WhatsApp.
          </p>
        </div>

        <div>
          <h4 className="font-display font-semibold text-white text-sm mb-2">Kontak</h4>
          <ul className="space-y-1.5 text-xs">
            <li className="flex items-center gap-2">
              <Phone className="w-3.5 h-3.5 text-[#e60012]" />
              <a href={`tel:+62${WA_NUMBER_LOCAL.slice(1)}`} className="hover:text-white" data-testid="footer-phone">
                {WA_NUMBER_LOCAL}
              </a>
            </li>
            <li className="flex items-center gap-2">
              <MapPin className="w-3.5 h-3.5 text-[#e60012]" />
              Kalimantan Barat, Indonesia
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-semibold text-white text-sm mb-2">Chat Cepat</h4>
          <a
            href={waLink}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-wa-cta"
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#25D366] hover:bg-[#1ebe57] text-white text-xs font-semibold transition"
          >
            <MessageCircle className="w-3.5 h-3.5" />
            Chat WhatsApp
          </a>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="y-container py-3 text-[10px] text-white/40 text-center">
          © {new Date().getFullYear()} YamahaKalbar · Website pribadi sales, bukan situs resmi Yamaha Indonesia.
          Harga & gambar dari yamaha-motor.co.id.
        </div>
      </div>
    </footer>
  );
}
